import { SectionBar } from '../SectionBar'
import { IconArrowRight, IconMail, IconPlus, IconTrash } from '@tabler/icons-react'
import { useI18n } from '../../../lib/i18n'

export function EmailsSection() {
  const { t } = useI18n()
  const rules = [
    { id: 1, alias: 'hola@miproyecto.com', destination: 'miemail@gmail.com', status: 'active' },
    { id: 2, alias: 'soporte@miproyecto.com', destination: 'ayuda@empresa.com', status: 'active' },
    { id: 3, alias: 'ventas@miproyecto.com', destination: 'carlos_ventas@gmail.com', status: 'pending' },
  ]

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24, paddingBottom: 64 }}>
      <SectionBar icon={<IconMail size={17} />} title={t('emails.title')} subtitle={t('emails.subtitle')}>
        <button className="dash-secondary-btn" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <IconPlus size={16} /> {t('emails.newRule')}
        </button>
      </SectionBar>

      <div style={{ background: 'var(--dash-panel-strong)', border: '1px solid var(--dash-border)', borderRadius: 0, padding: 24, display: 'flex', gap: 24, alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{ background: 'rgba(59, 130, 246, 0.1)', padding: 16, borderRadius: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{/* accent-ok: tinte y color del área Correos, no el acento */}
          {/* accent-ok: color del área Correos */}
          <IconMail size={32} color="#3b82f6" />
        </div>
        <div style={{ flex: 1, minWidth: 250 }}>
          <h3 className="dash-card-title" style={{ marginBottom: 4 }}>{t('emails.needDomainTitle')}</h3>
          <p className="dash-card-description">{t('emails.needDomainBody', { example: 'hola@tu-dominio.com' })}</p>
        </div>
        <button className="dash-primary-btn" type="button">{t('emails.connectDomain')}</button>
      </div>

      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 className="dash-card-title">{t('emails.rulesTitle')}</h3>
          <button className="dash-secondary-btn" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <IconPlus size={16} /> {t('emails.newRule')}
          </button>
        </div>

        <div style={{ background: 'var(--dash-panel)', border: '1px solid var(--dash-border)', borderRadius: 0, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
            <thead style={{ background: 'rgba(255,255,255,0.02)', borderBottom: '1px solid var(--dash-border)' }}>
              <tr>
                <th className="dash-table-heading" style={{ padding: '16px 24px' }}>{t('emails.colAlias')}</th>
                <th className="dash-table-heading" style={{ padding: '16px 24px' }}></th>
                <th className="dash-table-heading" style={{ padding: '16px 24px' }}>{t('emails.colDestination')}</th>
                <th className="dash-table-heading" style={{ padding: '16px 24px' }}>{t('emails.colStatus')}</th>
                <th className="dash-table-heading" style={{ padding: '16px 24px', textAlign: 'right' }}>{t('emails.colActions')}</th>
              </tr>
            </thead>
            <tbody>
              {rules.map((rule, i) => (
                <tr key={rule.id} style={{ borderBottom: i < rules.length - 1 ? '1px solid var(--dash-border)' : 'none' }}>
                  <td className="dash-card-primary" style={{ padding: '16px 24px' }}>{rule.alias}</td>
                  <td style={{ padding: '16px 8px', textAlign: 'center' }}>
                    <IconArrowRight size={16} color="var(--dash-muted)" />
                  </td>
                  <td className="dash-card-primary" style={{ padding: '16px 24px', fontWeight: 400 }}>{rule.destination}</td>
                  <td style={{ padding: '16px 24px' }}>
                    <span className="dash-status-label" style={{
                      padding: '4px 8px', borderRadius: 0,
                      background: rule.status === 'active' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(245, 158, 11, 0.1)',
                      color: rule.status === 'active' ? '#10b981' : '#f59e0b',
                      border: `1px solid ${rule.status === 'active' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(245, 158, 11, 0.2)'}`
                    }}>
                      {t(rule.status === 'active' ? 'emails.active' : 'emails.pending')}
                    </span>
                  </td>
                  <td style={{ padding: '16px 24px', textAlign: 'right' }}>
                    <button style={{ background: 'transparent', border: 'none', color: 'var(--dash-muted)', cursor: 'pointer', padding: 4 }} title={t('emails.deleteRule')}>
                      <IconTrash size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
